import React, {createRef, Component} from 'react';
import AddForm from './AddForm/AddForm';
import Modal from './Modal/Modal';
import Somemap from './Map/Map';
import './App.css';

import backImage from './img/back.png';

import axios from 'axios';

class App extends Component {
    state = {
        currentLang: window.lang || 'ua',
        locale: null,
        addFind: new URL(window.location.href).searchParams.get("type") === "found",
        addLost: new URL(window.location.href).searchParams.get("type") === "lost",
        showMap: false,
        showSubListAddress: false,
        address: '',
        addressArr: [],
        center: {
            lat: 50.45466,
            lng: 30.5238,
        },
        marker: {
            lat: 50.45466,
            lng: 30.5238,
        },
        zoom: 13,
        count: 13,
        draggable: true
    }

    componentDidMount() {
        document.addEventListener("keydown", this.escFunc, false)
        axios
            .get(`https://www.luckfind.me/api/v1/locales/?lang=${this.state.currentLang}`)
            .then(response => {
                if (response.data) {
                    this.setState({
                        locale: JSON.parse(response.data)
                    });
                } else {
                    throw new Error("Locales not found");
                }
            })
    }

    refmarker = createRef()

    toggleDraggable = () => {
        this.setState({draggable: !this.state.draggable})
    }

    updatePosition = () => {
        const marker = this.refmarker.current

        if (marker !== null) {
            this.setState({
                marker: marker.leafletElement.getLatLng(),
            })
            axios.get(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${this.state.marker.lat}&lon=${this.state.marker.lng}`)
                .then(result => {
                    let addressDetail = Object.values(result.data.address).join(', ')
                    this.setState({
                        address: addressDetail,
                        center: {lat: this.state.marker.lat, lng: this.state.marker.lng},
                        zoom: this.state.count
                    })
                })
        }
    }

    changeStateToFalse = (event, stateName) => {
        if (event.target.name !== 'searchAddressInput') {
            this.setState({
                [stateName]: false
            })
        }
    }

    changeStateToTrue = (event, stateName) => {
        if (event.target.name === 'searchAddressInput') {
            this.setState({
                [stateName]: true
            })
        }
    }

    toggleMap = () => {
        this.setState(prevState => ({
            showMap: !prevState.showMap
        }))
    }

    escFunc = (event) => {
        if (event.keyCode === 27) {
            this.setState({
                showMap: false
            })
        }
    }

    handleChange = (event) => {
        let value = event.target.value
        this.setState({
            address: event.target.value,
        })
        axios.get(`https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&q=${value}`)
            .then(response => {
                    let i = 1;
                    if (!!response.data.length) {
                        let newArr = response.data.map(el => {
                                let obj = {address: el, id: ++i + '123address'}
                                return obj
                            }
                        )
                        this.setState({
                            addressArr: [...newArr]
                        })
                    } else {
                        this.setState({
                            addressArr: []
                        })
                    }
                }
            )
    }


    chooseAddress = (event) => {
        let id = event.target.id
        let targetAddress = this.state.addressArr.filter(el => el.id === id)
        this.setState({
            address: targetAddress[0].address.display_name,
            addressArr: [],
            center: {lat: targetAddress[0].address.lat, lng: targetAddress[0].address.lon},
            marker: {lat: targetAddress[0].address.lat, lng: targetAddress[0].address.lon}
        })
    }

    countPlus = () => {
        this.setState(prevState => ({
            count: prevState.count + 1
        }))
    }
    countMinus = () => {
        this.setState(prevState => ({
            count: prevState.count - 1
        }))
    }

    render() {

        if (!this.state.locale) return null;

        return (
            <div className="App" onClick={(event) => this.changeStateToFalse(event, 'showSubListAddress')}>
                {
                    (this.state.addFind || this.state.addLost) &&
                    <AddForm
                        langProps={this.state.locale}
                        backGroundColorProps={(this.state.addFind && 'checkLineImg-wrapperGreen') || (this.state.addLost && 'checkLineImg-wrapperOrange')}
                        classTextColorProps={(this.state.addFind && 'greenColor') || (this.state.addLost && 'orangeColor')}
                        lostProps={this.state.addLost}
                        findProps={this.state.addFind}
                        showMapFuncProps={this.toggleMap}
                        addressProps={this.state.address}
                        addressArrProps={this.state.addressArr}
                        chooseAddressFuncProps={event => this.chooseAddress(event)}
                        handleChangeFuncProps={event => this.handleChange(event)}
                        showSubListAddressFunc={(event) => this.changeStateToTrue(event, 'showSubListAddress')}
                        showSubListAddress={this.state.showSubListAddress}
                        markerLat={this.state.marker.lat}
                        markerLng={this.state.marker.lng}
                        currentLang={this.state.currentLang}
                    />
                }
                {this.state.showMap && <Somemap
                    countPlus={this.countPlus}
                    countMinus={this.countMinus}
                    showMapFuncProps={this.toggleMap}
                    classNameProps={'leaflet-wrapperMap'}
                    imgSrcProps={backImage}
                    addressProps={this.state.address}
                    addressArrProps={this.state.addressArr}
                    chooseAddressFuncProps={event => this.chooseAddress(event)}
                    handleChangeFuncProps={event => this.handleChange(event)}
                    zoom={this.state.zoom}
                    count={this.state.count}
                    draggable={this.state.draggable}
                    onDragend={this.updatePosition}
                    refProps={this.refmarker}
                    toggleDraggable={this.toggleDraggable}
                    position={[this.state.center.lat, this.state.center.lng]}
                    markerPosition={[this.state.marker.lat, this.state.marker.lng]}
                    showSubListAddress={this.state.showSubListAddress}
                    showSubListAddressFunc={(event) => this.changeStateToTrue(event, 'showSubListAddress')}
                />}
                <Modal
                    text={this.state.locale.step1.textAreaModalText}
                    buttonText={this.state.locale.step1.textAreaModalButton}
                />
            </div>
        )
            ;
    }
}

export default App;
